export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Arrow-Up-Gray-2566fc0de8dac6b11fafe3aff4cf48d1.svg";